var _defs, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInlineInfo = function SvgInlineInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#241c15;}.b{fill:#241c15;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8,
    cy: 8,
    r: 7.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.313-2.121A.312.312,0,0,0,0-1.809v.746A.312.312,0,0,0,.313-.75H2.688A.312.312,0,0,0,3-1.062v-.746a.312.312,0,0,0-.312-.312H2.375V-5.437a.312.312,0,0,0-.312-.312H.313A.312.312,0,0,0,0-5.437v.746a.312.312,0,0,0,.313.313H.625v2.257ZM1.5-8.75A1.125,1.125,0,0,0,.375-7.625,1.125,1.125,0,0,0,1.5-6.5,1.125,1.125,0,0,0,2.625-7.625,1.125,1.125,0,0,0,1.5-8.75Z",
    transform: "translate(6.75 12.75)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInlineInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inline-info.a6f7b159.svg";
export { ForwardRef as ReactComponent };